"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIBadge = _interopRequireDefault(require("../../badge/UIBadge"));

var _UIButton = _interopRequireDefault(require("../../button/UIButton"));

var _Small = _interopRequireDefault(require("../../elements/Small"));

var _UIIcon = _interopRequireDefault(require("../../icon/UIIcon"));

var _UIImage = _interopRequireDefault(require("../../image/UIImage"));

var _UICheckbox = _interopRequireDefault(require("../../input/UICheckbox"));

var _UIFlex = _interopRequireDefault(require("../../layout/UIFlex"));

var _UILoadingSpinner = _interopRequireDefault(require("../../loading/UILoadingSpinner"));

var _UITag = _interopRequireDefault(require("../../tag/UITag"));

var _OptionTypes = require("../../types/OptionTypes");

var _DomEvents = require("../../utils/DomEvents");

var _component = _interopRequireDefault(require("../../utils/propTypes/component"));

// No-break space ensures that blank items are sized properly
var BLANK_LABEL = "\xA0";
var instanceCount = 0;

var UITypeaheadResultsItem =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITypeaheadResultsItem, _PureComponent);

  function UITypeaheadResultsItem(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UITypeaheadResultsItem);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITypeaheadResultsItem).call(this, props));
    instanceCount += 1;
    _this._checkboxId = "uitri-checkbox-" + instanceCount;
    return _this;
  }

  (0, _createClass2.default)(UITypeaheadResultsItem, [{
    key: "getButtonClassName",
    value: function getButtonClassName(_ref) {
      var message = _ref.message,
          option = _ref.option;
      return (0, _classnames.default)({
        'private-typeahead-result-label': !message,
        'private-typeahead-result-heading': option.options && !option.selectAll,
        uiTypeaheadResults__item: true,
        'truncate-text': !message,
        'p-y-2': message,
        'p-x-5': message
      });
    }
  }, {
    key: "getClassName",
    value: function getClassName(_ref2) {
      var highlighted = _ref2.highlighted,
          _ref2$option = _ref2.option,
          disabled = _ref2$option.disabled,
          dropdownClassName = _ref2$option.dropdownClassName;
      return (0, _classnames.default)('private-typeahead-result', dropdownClassName, {
        'private-typeahead-result--highlighted': highlighted && !disabled,
        'private-typeahead-result--selectable': !disabled,
        'private-typeahead-result--disabled': disabled
      });
    }
  }, {
    key: "getLoadingIndicator",
    value: function getLoadingIndicator(computedButtonText) {
      return _react.default.createElement(_UIFlex.default, {
        align: "center"
      }, computedButtonText, _react.default.createElement(_UILoadingSpinner.default, {
        className: "private-typeahead-result__loading-indicator",
        size: "extra-small",
        use: "tertiary"
      }));
    }
  }, {
    key: "getLabel",
    value: function getLabel(_ref3) {
      var _ref3$option = _ref3.option,
          buttonText = _ref3$option.buttonText,
          dropdownText = _ref3$option.dropdownText,
          loading = _ref3$option.loading,
          text = _ref3$option.text,
          value = _ref3$option.value,
          _useDropdownText = _ref3._useDropdownText;
      var fallbackText = text || (value == null ? '' : value.toString());

      if (_useDropdownText) {
        return dropdownText == null ? fallbackText : dropdownText;
      }

      var computedButtonText = buttonText == null ? fallbackText : buttonText;

      if (loading) {
        return this.getLoadingIndicator(computedButtonText);
      } else {
        return computedButtonText;
      }
    }
  }, {
    key: "getTitle",
    value: function getTitle(_ref4) {
      var _ref4$option = _ref4.option,
          text = _ref4$option.text,
          title = _ref4$option.title,
          value = _ref4$option.value;

      if (title === '') {
        return null;
      }

      return title || text || (value == null ? '' : value.toString());
    }
  }, {
    key: "renderHelp",
    value: function renderHelp(_ref5) {
      var _ref5$option = _ref5.option,
          disabled = _ref5$option.disabled,
          help = _ref5$option.help;

      if (help) {
        return _react.default.createElement(_Small.default, {
          className: "private-typeahead-results-item__help",
          disabled: disabled,
          use: "help"
        }, help);
      }

      return null;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(_ref6, _ref7) {
      var search = _ref6.search;
      var computedLabel = _ref7.computedLabel;

      if (!computedLabel) {
        return BLANK_LABEL;
      }

      if (!search || typeof computedLabel !== 'string') {
        return computedLabel;
      }

      var searchResult = search.exec(computedLabel);

      if (!searchResult) {
        return computedLabel;
      }

      var match = searchResult[0];
      var head = computedLabel.slice(0, searchResult.index);
      var tail = computedLabel.slice(searchResult.index + match.length);
      return _react.default.createElement("span", null, head, _react.default.createElement("span", null, match), tail);
    }
  }, {
    key: "renderItemImage",
    value: function renderItemImage(_ref8) {
      var _ref8$option = _ref8.option,
          avatar = _ref8$option.avatar,
          icon = _ref8$option.icon,
          imageUrl = _ref8$option.imageUrl;

      if (avatar) {
        return _react.default.cloneElement(avatar, {
          className: (0, _classnames.default)(avatar.props.className, 'private-dropdown__item__decoration', 'private-dropdown__item__image')
        });
      }

      if (icon) {
        return _react.default.createElement(_UIIcon.default, {
          className: "private-dropdown__item__decoration",
          name: icon
        });
      }

      if (imageUrl) {
        return _react.default.createElement(_UIImage.default, {
          className: (0, _classnames.default)('uiTypeaheadResults__image', 'private-dropdown__item__decoration', 'private-dropdown__item__image'),
          src: imageUrl
        });
      }

      return null;
    }
  }, {
    key: "renderTag",
    value: function renderTag(_ref9) {
      var tag = _ref9.option.tag;

      if (!tag) {
        return null;
      }

      return _react.default.createElement(_UITag.default, {
        inline: true,
        use: tag.use
      }, tag.text);
    }
  }, {
    key: "renderBadge",
    value: function renderBadge(_ref10) {
      var badge = _ref10.option.badge;

      if (!badge) {
        return null;
      }

      if (_react.default.isValidElement(badge)) {
        return _react.default.cloneElement(badge, {
          className: (0, _classnames.default)(badge.props.className, 'private-dropdown__badge')
        });
      } // Support object params (legacy)


      return _react.default.createElement(_UIBadge.default, {
        className: "private-dropdown__badge",
        use: badge.use
      }, badge.text);
    }
  }, {
    key: "renderContent",
    value: function renderContent(_ref11) {
      var renderedItemImage = _ref11.renderedItemImage,
          renderedLabel = _ref11.renderedLabel,
          renderedTag = _ref11.renderedTag,
          renderedBadge = _ref11.renderedBadge,
          toggleable = _ref11.toggleable;
      return _react.default.createElement("span", {
        className: toggleable ? 'private-dropdown__item--toggleable' : ''
      }, renderedItemImage, ' ', _react.default.createElement("span", {
        className: "private-dropdown__item__label",
        "data-option-text": true
      }, renderedLabel), ' ', renderedTag, " ", renderedBadge);
    }
  }, {
    key: "renderButton",
    value: function renderButton(_ref12, _ref13) {
      var rest = _ref12.rest;
      var computedButtonClassName = _ref13.computedButtonClassName,
          computedTitle = _ref13.computedTitle,
          renderedContent = _ref13.renderedContent,
          renderedHelp = _ref13.renderedHelp;
      return _react.default.createElement("span", null, _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, rest, {
        className: computedButtonClassName,
        tabIndex: -1,
        title: computedTitle,
        use: "unstyled"
      }), renderedContent), renderedHelp);
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox(_ref14, _ref15) {
      var isIndeterminate = _ref14.isIndeterminate,
          isSelected = _ref14.isSelected,
          onToggle = _ref14.onToggle,
          option = _ref14.option,
          style = _ref14.style;
      var computedTitle = _ref15.computedTitle,
          renderedContent = _ref15.renderedContent,
          renderedHelp = _ref15.renderedHelp;
      return _react.default.createElement("label", {
        // Route clicks on help text to checkbox
        style: {
          cursor: 'pointer'
        },
        onMouseDown: _DomEvents.stopPropagationHandler // Prevent double-toggle

      }, _react.default.createElement(_UICheckbox.default, {
        className: "private-typeahead-result-label",
        checked: isSelected,
        disabled: isSelected && option.clearableValue === false,
        id: this._checkboxId,
        indeterminate: isIndeterminate,
        onChange: onToggle,
        style: style,
        title: computedTitle
      }, renderedContent), renderedHelp);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          highlighted = _this$props.highlighted,
          id = _this$props.id,
          isIndeterminate = _this$props.isIndeterminate,
          isSelected = _this$props.isSelected,
          Item = _this$props.itemComponent,
          message = _this$props.message,
          onMouseEnter = _this$props.onMouseEnter,
          onToggle = _this$props.onToggle,
          option = _this$props.option,
          search = _this$props.search,
          style = _this$props.style,
          toggleable = _this$props.toggleable,
          _useButton = _this$props._useButton,
          _useDropdownText = _this$props._useDropdownText,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["highlighted", "id", "isIndeterminate", "isSelected", "itemComponent", "message", "onMouseEnter", "onToggle", "option", "search", "style", "toggleable", "_useButton", "_useDropdownText"]); // Escape hatch for dividers

      if (option.rawNode) return option.rawNode;
      var computedAriaSelected = highlighted || null;
      var computedItemClassName = this.getClassName({
        highlighted: highlighted,
        option: option
      });
      var computedButtonClassName = this.getButtonClassName({
        message: message,
        option: option
      });
      var computedTitle = this.getTitle({
        option: option
      });
      var computedLabel = this.getLabel({
        option: option,
        _useDropdownText: _useDropdownText
      });
      var renderedItemImage = this.renderItemImage({
        option: option
      });
      var renderedLabel = this.renderLabel({
        search: search
      }, {
        computedLabel: computedLabel
      });
      var renderedTag = this.renderTag({
        option: option
      });
      var renderedBadge = this.renderBadge({
        option: option
      });
      var renderedHelp = this.renderHelp({
        option: option,
        toggleable: toggleable
      });
      var renderedContent = this.renderContent({
        renderedItemImage: renderedItemImage,
        renderedLabel: renderedLabel,
        renderedTag: renderedTag,
        renderedBadge: renderedBadge,
        toggleable: toggleable
      }); // If _useButton={true}, wrap content in a button

      renderedContent = _useButton ? this.renderButton({
        rest: rest
      }, {
        computedButtonClassName: computedButtonClassName,
        computedTitle: computedTitle,
        renderedContent: renderedContent,
        renderedHelp: renderedHelp
      }) : renderedContent; // If toggleable={true}, wrap content in a checkbox

      renderedContent = toggleable ? this.renderCheckbox({
        isIndeterminate: isIndeterminate,
        isSelected: isSelected,
        onToggle: onToggle,
        option: option,
        style: style
      }, {
        computedTitle: computedTitle,
        renderedContent: renderedContent,
        renderedHelp: renderedHelp
      }) : renderedContent;

      if (typeof Item === 'function') {
        return _react.default.createElement(Item, (0, _extends2.default)({}, rest, {
          "aria-selected": computedAriaSelected,
          id: id,
          onMouseEnter: onMouseEnter,
          option: option,
          className: computedItemClassName,
          "data-option-value": option.value,
          role: "option"
        }), renderedContent);
      }

      return _react.default.createElement(Item, {
        "aria-selected": computedAriaSelected,
        className: computedItemClassName,
        "data-option-value": option.value,
        id: id,
        onMouseEnter: onMouseEnter,
        role: "option"
      }, renderedContent);
    }
  }]);
  return UITypeaheadResultsItem;
}(_react.PureComponent);

exports.default = UITypeaheadResultsItem;
UITypeaheadResultsItem.displayName = 'UITypeaheadResultsItem';
UITypeaheadResultsItem.propTypes = {
  highlighted: _propTypes.default.bool.isRequired,
  itemComponent: _component.default,
  isIndeterminate: _propTypes.default.bool.isRequired,
  isSelected: _propTypes.default.bool.isRequired,
  message: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  option: _OptionTypes.OptionOrGroupType.isRequired,
  search: _propTypes.default.instanceOf(RegExp),
  toggleable: _propTypes.default.bool.isRequired,
  _useButton: _propTypes.default.bool,
  _useDropdownText: _propTypes.default.bool
};
UITypeaheadResultsItem.defaultProps = {
  highlighted: false,
  isIndeterminate: false,
  isSelected: false,
  itemComponent: 'li',
  toggleable: false,
  _useButton: true,
  _useDropdownText: true
};
module.exports = exports.default;